import Vue from 'vue';
//axios数据交互
import axios from 'axios'
//将对象序列化，多个对象之间用&拼接 qs.stringify()转换成查询字符串  qs.parse() 转换成json对象
import qs from 'qs'
Vue.prototype.axios = axios;
axios.defaults.timeout=30000
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'

let Base = 'https://www.hainingyunjiance.com/'
function headerUrl (url) {
  url = Base + url
  return url
}
//POST传参序列化(添加请求拦截器)
axios.interceptors.request.use((config) => {
  if(config.method  === 'post'){
    config.data = qs.stringify(config.data)//序列化post 参数
  }
  return config;
},(error) =>{
  console.log('错误的传参')
  return Promise.reject(error);
});
//返回状态判断(添加响应拦截器)
axios.interceptors.response.use((res) =>{
  //对响应数据做些事
  return res;
}, (error) => {
  return Promise.reject(error);
});
//返回一个Promise(发送post请求)
function post(url, params) {
  return new Promise((resolve, reject) => {
    axios.post(headerUrl(url), params)
      .then(response => {
        resolve(response);
      }, err => {
        reject(err);
      })
      .catch((error) => {
        reject(error)
      })
  })
}
//返回一个Promise(发送get请求)
function get(url, param) {
  return new Promise((resolve, reject) => {
    axios.get(headerUrl(url), {params: param})
      .then(response => {
        resolve(response)
      }, err => {
        reject(err)
      })
      .catch((error) => {
        reject(error)
      })
  })
}
export default {
  get,
  post,
}



// WEBPACK FOOTER //
// ./src/axios.config.js